import { DotIcon } from "lucide-react"

import Logo from "./logo"
import ThemeToggle from "./theme-toggle"
import BeepAnimation from "./beep-animation"

interface IProps { isLoading?: boolean }

export default function Header({ isLoading }: IProps) {
    return <header className="border-b border-b-primary-foreground sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 pt-4">
            <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-center gap-3 mb-3">
                    <Logo />
                    <div>
                        <h1 className="text-xl font-black tracking-tighter text-primary">
                            OSINT SCANNER
                        </h1>
                        <p className="text-xs text-primary/70 font-mono tracking-widest uppercase">
                            Intelligence System
                        </p>
                    </div>
                </div>
                <div>
                    <div className="flex flex-row gap-2">
                        <ThemeToggle />
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-start gap-2 text-xs text-muted-foreground font-mono border-t border-primary/20 pt-3">
                <div className="flex flex-row items-center gap-2">
                    <BeepAnimation />
                    <span>LIVE</span>
                    <span>
                        <DotIcon />
                    </span>
                    <span>Multi-Platform Monitoring</span>
                </div>
            </div>
        </div>
    </header>
}